<template>
   <app-master>

       <div slot='breadcrumb'>
         <app-breadcrumb>
             <div class="title-box ttm-textcolor-white">
                <div class="page-title-heading">
                    <h1 class="title">Agribusiness Academy</h1>
                </div><!-- /.page-title-captions -->
                <div class="breadcrumb-wrapper">
                    <div class="container">
                        <div class="breadcrumb-wrapper-inner">
                            <span>
                                <router-link class="home" title='Go to AgroPark' to='/'><i class="themifyicon ti-home"></i>&nbsp;&nbsp;Home </router-link>
            
                            </span>
                            <span class="ttm-bread-sep">&nbsp; | &nbsp;</span>
                            <span>Faq</span>
                        </div>
                    </div>
                </div>
            </div>
         </app-breadcrumb>
       </div>
        



      <div slot='main_content'>

        <!--intro-section-->
        <section class="ttm-row intro-section clearfix">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6 col-sm-12">
                        <!-- ttm_single_image-wrapper -->
                        <div class="ttm_single_image-wrapper text-right">
                            <img class="img-fluid" src="/img/agric.png" alt="" />
                        </div><!-- ttm_single_image-wrapper end -->
                    </div>
                    <div class="col-lg-6 col-sm-12">
                        <div class="pt-50 pl-20 res-991-pl-0">
                            <!-- section title -->
                            <div class="section-title clearfix">
                                <div class="title-header">
                                    <h5>INTRODUCING</h5>
                                    <h2 class="title">We contribute significantly to Sector Growth through Human Capacity Building</h2>
                                </div>
                            </div><!-- section title end -->
                            <div class="mb-25 clearfix">
                                <p>Agribusiness has huge wealth generating potentials to transform millions of lives when properly harnessed, it is one sure way out of poverty. However, to make a sustainable success of this requires appropriate support structures to encourage the youths to take to farming, by making startup easier for new entrants as well as to transform substances farms into prosperous agribusiness.</p>
                            </div>
                            <div class="row">
                                <!-- <div class="col-md-6">
                                    <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey">
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Adult Trauma Center</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Birthing and Lactation Classes</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Dental and Oral Surgery</span></li>
                                    </ul>
                                </div> -->
                                <!-- <div class="col-md-6">
                                    <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey">
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Children's Trauma Center</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Heart and Vascular Institute</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Plastic Surgery</span></li>
                                    </ul>
                                </div> -->
                                <div class="col-lg-12">
                                    <div class="mt-5">
                                        <p>AAP in collaboration with our partners delivers agribusiness development schemes; we help to facilitate some of the much needed support initiatives.</p>
                                        <!-- <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-fill ttm-btn-color-skincolor mt-20" href="#">MORE ABOUT</a> -->
                                    </div>
                                </div>
                                <div class="col-lg-12">
                                    <div class="mt-5">
                                        <p>Agricultural Education and Training to Financing, Insurance and Agricultural Produce marketing and sales. These initiatives are to create wealth for the people and make agriculture a major socio-economic development contributor.</p>
                                        <!-- <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-fill ttm-btn-color-skincolor mt-20" href="#">MORE ABOUT</a> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!-- row end -->
            </div>
        </section>
        <!--intro-section end-->


        <!--service-section-->
        <section class="ttm-row service-section ttm-bgcolor-grey clearfix">
            <div class="container">
                <!-- row -->
                <div class="row">
                    <div class="col-lg-9 col-md-12">
                        <!-- section-title -->
                        <div class="section-title with-desc clearfix">
                            <div class="title-header">
                                <h5>TRAIN WITH US</h5>
                                <h2 class="title">Agribusiness Academy Training Module</h2>
                            </div>
                            <div class="title-desc">Agribusiness Academy offer a broad curriculum of Agro-related courses in the fundamentals, practical, financials, entrepreneurship, and networking, with mentoring on how to create business plans and reports, and support to launch your own business. We offer a broad curriculum of Agro-related courses. Training modules are designed to provide sectoral practical learning as well as mentorship, and networking opportunities.</div>
                        </div><!-- section-title end -->
                    </div>
                    <div class="col-lg-3 col-md-12">
                        <router-link tag="a" to="/agribusiness-academy" class="ttm-btn ttm-btn-size-md ttm-btn-shape-square ttm-btn-style-border ttm-btn-color-black mb-30 mt-45 res-991-mt-0 float-right">ALL DEPARTMENTS</router-link>
                    </div>
                </div><!-- row end -->
                <div class="row">
                    <div class="col-lg-12">
                        <div class="row row-equal-height ttm-bgcolor-white ttm-box-seperator ttm-row-seperator box-shadow mt-20">
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <!-- featured-icon-box -->
                                <div class="featured-icon-box top-icon featured-icon-hover">
                                    <div class="featured-icon">
                                        <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                            <i class="flaticon-report"></i>
                                        </div>
                                    </div>
                                    <div class="featured-content">
                                        <div class="featured-title">
                                            <h5>AGRIBUSINESS AND ENTERPRISE DEVELOPMENT</h5>
                                        </div>
                                        <div class="featured-desc">
                                        <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey">
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Introduction to Agribusiness Entrepreneurship</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Basic Principles of Agribusiness Entrepreneurship</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Skills in Agribusiness Planning Practices</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Opportunities in Agribusiness</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Generate Your Business Idea</span></li>
                                    </ul>
                                            <!-- <p>Our paediatric services utilizes state technology and employs team of experts for paediatric.</p> -->
                                        </div>
                                    </div>
                                </div><!-- featured-icon-box end-->
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <!-- featured-icon-box -->
                                <div class="featured-icon-box top-icon featured-icon-hover">
                                    <div class="featured-icon">
                                        <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                            <i class="flaticon-charity"></i>
                                        </div>
                                    </div>
                                    <div class="featured-content">
                                        <div class="featured-title">
                                            <h5>FUNDAMENTALS OF AGRIBUSINESS ENTREPRENEURSHIP</h5>
                                        </div>
                                        <div class="featured-desc">
                                            <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey">
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Basic Principles of Agri Entrepreneurship</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Start Your Business</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Essentials of Agribusiness Entrepreneurship</span></li>
                                         <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Agribusiness Network and Alliances</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Farm & Factory Tour</span></li>
                                    </ul>
                                            <!-- <p>We offer for severals services helps with yours neurological condition our patient services.</p> -->
                                        </div>
                                    </div>
                                </div>
                                <!-- featured-icon-box end-->
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                                <!-- featured-icon-box -->
                                <div class="featured-icon-box top-icon featured-icon-hover">
                                    <div class="featured-icon">
                                        <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                            <i class="flaticon-list"></i>
                                        </div>
                                    </div>
                                    <div class="featured-content">
                                        <div class="featured-title">
                                            <h5>BACK TO THE FARM PROGRAMME (Farming made simple)</h5>
                                        </div>
                                        <div class="featured-desc">
                                            <ul class="ttm-list ttm-list-style-icon ttm-list-icon-color-skincolor ttm-textcolor-darkgrey">
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Develop a Feasibility Report</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Create a Business Plan</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Financing Options</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Mentoring and Coaching</span></li>
                                        <li><i class="fa fa-arrow-circle-right"></i><span class="ttm-list-li-content">Farm & Factory Tour</span></li>
                                    </ul>
                                            <!-- <p>Your heart is the best hands state-of-the-arts cardiovascu-lar of the cardiology institute.</p> -->
                                        </div>
                                    </div>
                                </div><!-- featured-icon-box end-->
                            </div>
                            <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"> -->
                                <!-- featured-icon-box -->
                                <!-- <div class="featured-icon-box top-icon featured-icon-hover">
                                    <div class="featured-icon">
                                        <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                            <i class="flaticon-dentist"></i>
                                        </div>
                                    </div>
                                    <div class="featured-content">
                                        <div class="featured-title">
                                            <h5>Dental Care</h5>
                                        </div>
                                        <div class="featured-desc">
                                            <p>We offers a greats dental cares including cosmetic and an oral dental implant emergency care.</p>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- featured-icon-box end-->
                            <!-- </div> -->
                            <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"> -->
                                <!-- featured-icon-box -->
                                <!-- <div class="featured-icon-box top-icon featured-icon-hover">
                                    <div class="featured-icon">
                                        <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                            <i class="flaticon-walk"></i>
                                        </div>
                                    </div>
                                    <div class="featured-content">
                                        <div class="featured-title">
                                            <h5>Pulmonary</h5>
                                        </div>
                                        <div class="featured-desc">
                                            <p>Our endoscopic procedures is include is the bronchoscopys, thoracentesis,& tube insertion.</p>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- featured-icon-box end-->
                            <!-- </div> -->
                            <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"> -->
                                <!-- featured-icon-box -->
                                <!-- <div class="featured-icon-box top-icon featured-icon-hover">
                                    <div class="featured-icon">
                                        <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                            <i class="flaticon-microscope"></i>
                                        </div>
                                    </div>
                                    <div class="featured-content">
                                        <div class="featured-title">
                                            <h5>Laboratory</h5>
                                        </div>
                                        <div class="featured-desc">
                                            <p>In an our laboratory, You pass wide a range of the tests that allows us to n diagnosis tests.</p>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- featured-icon-box end-->
                            <!-- </div> -->
                            <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"> -->
                                <!-- featured-icon-box -->
                                <!-- <div class="featured-icon-box top-icon featured-icon-hover">
                                    <div class="featured-icon">
                                        <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                            <i class="flaticon-eye-2"></i>
                                        </div>
                                    </div>
                                    <div class="featured-content">
                                        <div class="featured-title">
                                            <h5>Eye Care</h5>
                                        </div>
                                        <div class="featured-desc">
                                            <p>Ours eye care services utilizes state technology and employs team of experts for paediatric.</p>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- featured-icon-box end-->
                            <!-- </div> -->
                            <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"> -->
                                <!-- featured-icon-box -->
                                <!-- <div class="featured-icon-box top-icon featured-icon-hover">
                                    <div class="featured-icon">
                                        <div class="ttm-icon ttm-icon_element-color-skincolor ttm-icon_element-size-lg">
                                            <i class="flaticon-form"></i>
                                        </div>
                                    </div>
                                    <div class="featured-content">
                                        <div class="featured-title">
                                            <h5>X-ray</h5>
                                        </div>
                                        <div class="featured-desc">
                                            <p>We offeres a greats x-ray cares including cosmetic and an oral dental implant emergency care.</p>
                                        </div>
                                    </div>
                                </div> -->
                                <!-- featured-icon-box end-->
                            <!-- </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--service-section end-->     
        
      </div>

   </app-master>
</template>

<script>
// @ is an alias to /src
import Master from "@/components/Master.vue"
import Breadcrumb from "@/components/Breadcrumb.vue"
import { seo } from "../Repositories/seo"

export default {
  name: "Faq",
  mixins: [seo],
  components: {
    "app-master" : Master,
    "app-breadcrumb" : Breadcrumb

  },
  created(){
      this.seoMetaData('Agribusiness Academy', '');
  }

};
</script>
